export default "__VITE_ASSET__DAuaWWRE__"